"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Exportamos por defecto las categorías de preguntas frecuentes
const categories = [
    // Aplicaciones
    {
        id: "aplicaciones",
        name: "Aplicaciones",
        enabled: true,
        description: "Preguntas frecuentes sobre las aplicaciones móviles de iOpos.",
        faqs: [
            {
                id: 1,
                question: "¿Necesito estar registrado para usar la/s aplicacion/es?",
                answer: [
                    "Sí, es necesario registrarse para acceder a la aplicación.",
                    "",
                    "Para guardar tu información de forma segura y mantener tus datos sincronizados, debes autenticarte con una cuenta. Actualmente puedes iniciar sesión usando **Gmail** o **Apple**, lo que garantiza un acceso rápido y seguro.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 2,
                question: "¿Puedo utilizar la aplicación/es en más de un dispositivo?",
                answer: [
                    "Sí, puedes utilizar la aplicación en varios dispositivos. Solo necesitas iniciar sesión con tu cuenta de **Gmail** o **Apple** para mantener todos tus datos sincronizados automáticamente.",
                    "",
                    "Ten en cuenta que **no está permitido compartir una misma cuenta entre diferentes usuarios**. Además, el acceso simultáneo está limitado a un máximo de **dos dispositivos**. El uso indebido de la cuenta podrá conllevar el **bloqueo permanente** del acceso a la aplicación.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 3,
                question: "¿Cómo puedo conseguir los módulos?",
                answer: [
                    "Para acceder a los módulos es necesario adquirirlos desde la propia aplicación. El pago se realiza actualmente mediante **PayPal**. Puedes consultar más detalles en nuestra página de [Formas de pago](/newversion/soporte/formas-de-pago-y-devoluciones).",
                    "",
                    "Ten en cuenta que la **duración de cada módulo depende del plan de suscripción contratado** y se cuenta siempre desde la fecha de activación.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 4,
                question: "¿Expiran las suscripciones a los módulos?",
                answer: [
                    "Sí. Las suscripciones a los módulos **caducan al finalizar el periodo contratado**, independientemente de su duración.",
                    "",
                    "Cada módulo puede tener un periodo distinto (mensual, trimestral, semestral, anual, etc.), y el tiempo comienza a contar desde la **fecha de activación**.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 5,
                question: "Si renuevo antes de que caduque, ¿pierdo días de suscripción?",
                answer: [
                    "No. Si renuevas tu suscripción antes de que caduque, **el tiempo de la renovación se añade al periodo que aún tengas activo**.",
                    "",
                    "Esto significa que **no perderás ningún día** de tu suscripción actual, independientemente de la duración del módulo que tengas contratado.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 6,
                question: "¿Cómo puedo reportar o impugnar una pregunta que creo que es incorrecta?",
                answer: [
                    "Hemos añadido una opción para **impugnar preguntas** directamente desde la aplicación.",
                    "",
                    "Para hacerlo, solo tienes que ir al menú **Histórico**, seleccionar el examen correspondiente y hacer clic sobre la pregunta que deseas impugnar. El sistema enviará automáticamente un correo a nuestro equipo con toda la información necesaria.",
                    "",
                    "Si lo prefieres, también puedes enviarnos una captura de pantalla de la pregunta a [info@iopos.academy](mailto:info@iopos.academy) indicándonos el error que has detectado.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 7,
                question: "¿Puedo pagar una suscripción con un método distinto a PayPal?",
                answer: [
                    "No. Actualmente la aplicación solo soporta **este método de pago** y no es posible utilizar alternativas.",
                    "",
                    "Si aún así necesitas ayuda adicional, también puedes escribirnos a [info@iopos.academy](mailto:info@iopos.academy).",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 8,
                question: "No puedo acceder a la aplicación, ¿qué puedo hacer?",
                answer: [
                    "Si tienes problemas para acceder a la aplicación, no te preocupes. En la mayoría de los casos se debe a errores de autenticación o a configuraciones del dispositivo.",
                    "",
                    "Puedes escribirnos a [info@iopos.academy](mailto:info@iopos.academy) explicándonos lo que ocurre. Nuestro equipo estará encantado de ayudarte y **resolver tu acceso lo antes posible**.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 9,
                question: "¿Puedo devolver un módulo una vez adquirido?",
                answer: [
                    "Sí, puedes solicitar la devolución de un módulo, pero solo en los casos permitidos por nuestra política de devoluciones.",
                    "",
                    "**Módulos de Test:** dispones de **14 días** desde la compra para solicitar un cambio o devolución, siempre que **no hayas realizado más de 15 test** dentro de ese módulo.",
                    "",
                    "**Módulos de Podcast:** dispones de **5 días** desde la compra para solicitar un cambio o devolución.",
                    "",
                    "Ten en cuenta que los **módulos de suscripción mensual (1 mes)** no admiten devolución una vez activados, incluso si la solicitud se realiza dentro de los plazos generales indicados para otros tipos de módulos.",
                    "",
                    "**Importante:** no se aceptarán devoluciones de módulos adquiridos en oferta si previamente se ha solicitado la devolución del mismo módulo. Tampoco se aceptarán devoluciones cuando el módulo haya sido **bloqueado por uso fraudulento o indebido**.",
                    "",
                    "Para cualquier duda, puedes escribirnos a [info@iopos.academy](mailto:info@iopos.academy).",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 10,
                question: "¿Cómo funcionan las disputas y devoluciones en PayPal u otros métodos de pago?",
                answer: [
                    "Antes de iniciar cualquier disputa con PayPal u otro método de pago, te recomendamos **contactar primero con nosotros**.",
                    "",
                    "En la mayoría de los casos podemos resolver la situación de forma rápida y directa, evitando procesos innecesarios. Puedes escribirnos a [info@iopos.academy](mailto:info@iopos.academy).",
                    "",
                    "En caso de que decidas abrir una disputa o solicitar un reembolso directamente a través del proveedor de pago (por ejemplo, PayPal), el proceso seguirá **las normas y procedimientos del propio proveedor**, y no nuestra política interna de devoluciones.",
                    "",
                    "Si el proceso genera **comisiones o costes adicionales** para iOpos Academia (como tasas por disputa), el usuario autoriza a que esos importes puedan ser descontados del reembolso correspondiente o, si fuera necesario, de su cuenta.",
                    "",
                    "Mientras la disputa esté activa, podremos **suspender temporalmente el acceso al módulo afectado** para evitar posibles usos indebidos o inconsistencias hasta que la situación quede completamente resuelta.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 11,
                question: "¿Cuánto tardan en hacerse efectivas las devoluciones?",
                answer: [
                    "Las devoluciones se procesan siempre mediante el **mismo método de pago** utilizado en la compra. En la mayoría de casos, será PayPal quien gestione el reembolso directamente en tu cuenta.",
                    "",
                    "Una vez que **iOpos Academia procesa la devolución**, el trámite pasa a ser responsabilidad del proveedor de pagos. A partir de ese momento, **no podemos acelerar, modificar ni intervenir** en el proceso.",
                    "",
                    "El plazo habitual de PayPal para reflejar un reembolso es de **entre 6 y 10 días laborables**, aunque puede variar según tu banco o entidad emisora.",
                    "",
                    "Si necesitas más información, puedes consultar la página oficial de ayuda de PayPal en [su centro de soporte](https://www.paypal.com/es/cshelp/article/%C2%BFd%C3%B3nde-est%C3%A1-mi-reembolso-help130).",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 12,
                question: "¿Puedo usar las aplicaciones en un ordenador (PC o Mac)?",
                answer: [
                    "No, actualmente la aplicación solo está disponible para dispositivos con **Android** o **iOS**. No existe una versión oficial para ordenadores.",
                    "",
                    "Si deseas utilizarla en un ordenador, puedes hacerlo instalando un **emulador de Android**, lo que te permitirá ejecutar la versión móvil de la aplicación.",
                    "",
                    "Existen varias opciones en el mercado que funcionan muy bien con nuestra app. Te recomendamos especialmente **BlueStacks** y **MemuPlay**.",
                    "",
                    "Ten en cuenta que la aplicación está **totalmente optimizada para un uso nativo en dispositivos móviles**. Para obtener el mejor rendimiento, estabilidad y experiencia de uso, te recomendamos utilizarla directamente en tu teléfono o tablet.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 13,
                question: "¿Cómo se calcula la puntuación de las clasificaciones?",
                answer: [
                    "La puntuación de las clasificaciones se calcula en función de varios factores que evalúan tu desempeño en cada test.",
                    "",
                    "Cada **respuesta correcta** suma puntos, mientras que las **respuestas incorrectas** restan una parte de la puntuación. Las **preguntas en blanco no se penalizan**.",
                    "",
                    "También se tiene en cuenta el **tiempo empleado** en completar el test: si te excedes en el tiempo recomendado, se aplica una pequeña penalización.",
                    "",
                    "Además, los tests con **más preguntas** tienen un peso ligeramente mayor en la puntuación final.",
                    "",
                    "En resumen, tu posición en la clasificación refleja tanto la **precisión de tus respuestas** como tu **eficiencia en la gestión del tiempo** y el tipo de test que hayas realizado.",
                    "",
                    "Para simplificar el sistema, hemos unificado las clasificaciones de la aplicación y la web. Ahora existe un único ranking dividido por intervalos de tiempo y actualizado cada 5 minutos, independientemente del intervalo que consultes:",
                    "",
                    "- **Clasificación semanal:** basada en los resultados obtenidos en la semana actual.",
                    "- **Clasificación mensual:** muestra tu rendimiento durante el mes en curso.",
                    "- **Clasificación anual:** refleja tu desempeño acumulado en el año actual.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 14,
                question: "He comprado un módulo y después lo he visto en oferta, ¿podéis ajustarme el precio o hacer devolución para comprarlo con descuento?",
                answer: [
                    "Las promociones y ofertas se aplican únicamente durante el periodo en el que están activas y no tienen carácter retroactivo.",
                    "",
                    "Por este motivo, si un módulo se compra y posteriormente entra en promoción, no podemos realizar devoluciones ni ajustes de precio para volver a comprarlo aplicando esa oferta.",
                    "",
                    "Si tienes cualquier duda adicional, puedes escribirnos a [info@iopos.academy](mailto:info@iopos.academy) y revisaremos tu caso de forma personalizada.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 15,
                question: "Estoy haciendo tests sin parar pero no subo en las clasificaciones, ¿por qué?",
                answer: [
                    "Que realices muchos tests no garantiza que tu posición en la clasificación suba.",
                    "",
                    "Recuerda que el ranking tiene en cuenta varios factores: el **intervalo de tiempo** seleccionado (semanal, mensual o anual), el **número de preguntas** de los tests que realices, la **puntuación obtenida** en cada uno y tu **rendimiento global**. Además, se actualiza cada 5 minutos, independientemente del intervalo que estés viendo.",
                    "",
                    "Es posible que no aparezcas en el **TOP 100** si no has realizado suficientes tests dentro del intervalo elegido o si tus puntuaciones no son lo suficientemente altas en comparación con otros usuarios.",
                    "",
                    "Te recomendamos seguir practicando con constancia y prestando atención tanto a la **precisión** como a la **gestión del tiempo**. Mejorando estos aspectos, tu posición en la clasificación irá subiendo de forma natural.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 16,
                question: "He adquirido un módulo de la app y no he hecho ningún test. ¿Se me puede reactivar sin coste?",
                answer: [
                    "No es posible. Las activaciones de los módulos dependen directamente de los sistemas operativos de Apple y Google Play. Cuando un usuario activa un módulo, esa activación queda registrada automáticamente en sus plataformas y se genera un cargo asociado que no podemos revertir ni repetir sin coste.",
                    "",
                    "Por este motivo, no es posible reactivar un módulo sin que su plataforma vuelva a contabilizar una nueva activación.",
                    "",
                    "De todos modos, si tienes cualquier duda o crees que ha habido un error, puedes escribirnos a [info@iopos.academy](mailto:info@iopos.academy) y revisaremos tu caso de forma personalizada.",
                ].join("\n"),
                enabled: true,
            },
        ],
    },
    // Libros
    {
        id: "libros",
        name: "Libros",
        description: "Preguntas frecuentes sobre la compra y envío de libros.",
        enabled: true,
        faqs: [
            {
                id: 1,
                question: "¿Cuanto tardan en enviarse los libros?",
                answer: [
                    "Los libros se envían **al día siguiente de la compra** mediante los servicios de **Correos**.",
                    "",
                    "El plazo de entrega habitual es de **3 a 4 días hábiles** en condiciones normales.",
                    "",
                    "El envío es **certificado**. Recibirás en tu correo electrónico el número de seguimiento en cuanto la empresa de transporte registre el paquete físicamente en su sistema.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 2,
                question: "¿Qué sucede si mi pedido se devuelve por una dirección incorrecta?",
                answer: [
                    "Si el pedido es devuelto porque la **dirección proporcionada es incorrecta o está incompleta**, los gastos del nuevo envío deberán ser asumidos por el cliente.",
                    "",
                    "Este coste corresponde al transporte adicional que genera el intento fallido de entrega.",
                    "",
                    "Te recomendamos revisar con atención tus **datos de envío** antes de completar la compra para evitar retrasos o costes adicionales.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 3,
                question: "¿Qué ocurre si no recojo mi pedido y es devuelto al remitente?",
                answer: [
                    "Si tu pedido es devuelto porque **no fue recogido dentro del plazo establecido** por la empresa de mensajería, no podremos realizar ningún reembolso, ni del producto ni de los gastos de envío.",
                    "",
                    "La devolución por falta de recogida se considera una incidencia ajena a iOpos Academia.",
                    "",
                    "Si deseas que te enviemos el pedido de nuevo, deberás abonar el **coste del nuevo envío**. Una vez recibido el pago y confirmada la dirección, gestionaremos el reenvío lo antes posible.",
                    "",
                    "Te recomendamos estar atento al **número de seguimiento** y a las notificaciones del transportista para evitar este tipo de incidencias.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 4,
                question: "He comprado un libro y después lo he visto en oferta, ¿podéis ajustarme el precio o hacer devolución para comprarlo con descuento?",
                answer: [
                    "Las promociones y ofertas se aplican únicamente durante el periodo en el que están activas y no tienen carácter retroactivo.",
                    "",
                    "Por este motivo, si un producto se compra y posteriormente entra en promoción, no podemos realizar devoluciones ni ajustes de precio para volver a comprarlo aplicando esa oferta.",
                    "",
                    "Si tienes cualquier duda adicional, puedes escribirnos a [info@iopos.academy](mailto:info@iopos.academy) y revisaremos tu caso de forma personalizada.",
                ].join("\n"),
                enabled: true,
            },
        ],
    },
    // Cursos
    {
        id: "cursos",
        name: "Cursos",
        enabled: true,
        description: "Preguntas frecuentes sobre los cursos presenciales y online.",
        faqs: [
            {
                id: 1,
                question: "¿Los cursos son presenciales u online?",
                answer: [
                    "Ofrecemos cursos tanto **presenciales** como **online**. El formato de cada curso se indica claramente en su anuncio o ficha de información.",
                    "",
                    "Los cursos online se realizan a través de nuestra **Plataforma de Cursos**.",
                    "",
                    "En el caso de los cursos presenciales, el lugar de realización puede variar en función del **número de inscritos** y de la disponibilidad de aulas, por lo que se confirmará la ubicación exacta una vez cerrado el grupo.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 2,
                question: "¿Puedo solicitar la devolución del importe de un cursos presencial?",
                answer: [
                    "Sí, puedes solicitar la devolución del importe de un **curso presencial**, siempre que lo hagas con al menos **5 días de antelación** antes del inicio del curso.",
                    "",
                    "Pasado ese plazo, **no es posible realizar reembolsos**.",
                    "",
                    "Los cursos presenciales requieren una planificación muy precisa: asignación de profesores, organización de horarios, gestión de aulas y coordinación logística. Cualquier cambio a última hora supone una reorganización completa del servicio.",
                    "",
                    "Para solicitar la devolución dentro del plazo permitido, puedes escribirnos directamente a [info@iopos.academy](mailto:info@iopos.academy).",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 3,
                question: "¿Puedo cambiar el horario de un curso una vez inscrito?",
                answer: [
                    "No se permiten **cambios de horario ni cambios de curso** en los últimos **5 días antes del inicio** del curso, ni una vez que el curso ya ha comenzado.",
                    "",
                    "Si necesitas realizar un cambio, deberás solicitarlo con al menos **5 días de antelación**.",
                    "",
                    "Esto nos permite reorganizar de forma adecuada la planificación de los profesores y asegurar el buen funcionamiento del curso.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 4,
                question: "¿Puedo solicitar la devolución del importe de un curso online?",
                answer: [
                    "Sí, puedes solicitar la devolución del importe de un curso online o remoto siempre que lo hagas dentro de los **5 días posteriores** a la compra del curso.",
                    "",
                    "Si necesitas ayuda con un caso concreto, puedes escribirnos directamente a [info@iopos.academy](mailto:info@iopos.academy).",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 5,
                question: "¿Puedo fraccionar una compra?",
                answer: [
                    "No ofrecemos financiación propia ni pagos a plazos directamente desde iOpos.",
                    "",
                    "Si PayPal te muestra una opción de fraccionamiento, será una decisión exclusiva de **PayPal** y dependerá de su evaluación como usuario.",
                    "",
                    "Por tanto, **iOpos Academia no financia compras** ni aprueba pagos a plazos. Cualquier opción de este tipo, si aparece, depende solo de PayPal.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 6,
                question: "¿Puedo comprar más de una unidad de un curso para mí y para otra persona?",
                answer: [
                    "Al comprar un curso o formación, se asigna una **matrícula individual** al usuario registrado con el correo electrónico proporcionado.",
                    "",
                    "Cada matrícula está vinculada a una única cuenta.",
                    "",
                    "Si deseas comprar **dos o más unidades** para ti y para otra(s) persona(s), deberás realizar **compras por separado**, utilizando el correo electrónico correspondiente a cada usuario que recibirá el curso.",
                    "",
                    "Si tienes alguna duda o necesitas ayuda con el proceso, puedes escribirnos a [info@iopos.academy](mailto:info@iopos.academy) y evaluaremos tu caso de forma personalizada.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 7,
                question: "Quiero regalar un curso a otra persona. ¿Cómo puedo hacerlo?",
                answer: [
                    "Sí, puedes regalar uno o varios cursos a otra persona.",
                    "",
                    "Al realizar la compra, solo debes introducir el **correo** y el **nombre** de la persona a quien deseas regalarlo.",
                    "",
                    "En el momento de efectuar el pago, puedes utilizar sin problema tus propios datos personales y tu método de pago habitual.",
                    "",
                    "La activación del curso se enviará al destinatario que indiques.",
                    "",
                    "Si tienes alguna duda o necesitas ayuda con el proceso, puedes escribirnos a [info@iopos.academy](mailto:info@iopos.academy) y evaluaremos tu caso de forma personalizada.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 8,
                question: "¿Podéis reactivarme un curso que no utilicé antes de que caducara?",
                answer: [
                    "La plataforma de e-learning que utilizamos es un servicio externo que nos factura por cada usuario activo y por cada matrícula realizada. Esto significa que, en el momento en que un alumno se inscribe en un curso, se genera un coste automático para la academia, independientemente de si llega a utilizar el curso o no.",
                    "",
                    "Dado que el curso ya ha finalizado, reactivar tu acceso implicaría generar una matrícula nueva, lo que supondría un coste adicional que la academia no puede asumir.",
                    "",
                    "Si tienes cualquier duda adicional, puedes escribirnos a [info@iopos.academy](mailto:info@iopos.academy) y revisaremos tu caso de forma personalizada.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 9,
                question: "¿Cuándo puedo solicitar la garantía de devolución del 50 % del Curs Preparació Tercera Prova Mossos d'Esquadra 2026 (incluido test biodata)?",
                answer: [
                    "La **garantía de devolución del 50 %** del importe del **Test Oficial de Biodata** está pensada exclusivamente para aquellos aspirantes que no superen alguna de las **pruebas previas vinculadas al proceso selectivo**, es decir, las fases anteriores a la tercera prueba (por ejemplo, la prueba teórica, los psicotécnicos o las pruebas físicas, según corresponda en la convocatoria).",
                    "",
                    "Esta garantía **no es aplicable** una vez el aspirante ha accedido a la **tercera prueba (Biodata y entrevista)** ni tras la publicación de los resultados de esta fase, independientemente de que el resultado haya sido **APTO** o **NO APTO**.",
                    "",
                    "Su finalidad es ofrecer una garantía a quienes adquieren el producto y finalmente no llegan a poder realizar la **tercera prueba del proceso selectivo**.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 10,
                question: "He comprado un producto y después lo he visto en oferta, ¿podéis ajustarme el precio o hacer devolución para comprarlo con descuento?",
                answer: [
                    "Las promociones y ofertas se aplican únicamente durante el periodo en el que están activas y no tienen carácter retroactivo.",
                    "",
                    "Por este motivo, si un producto se compra y posteriormente entra en promoción, no podemos realizar devoluciones ni ajustes de precio para volver a comprarlo aplicando esa oferta.",
                    "",
                    "Si tienes cualquier duda adicional, puedes escribirnos a [info@iopos.academy](mailto:info@iopos.academy) y revisaremos tu caso de forma personalizada.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 11,
                question: "¿Se puede descargar el material del campus?",
                answer: [
                    "**No. El material del campus está diseñado para ser consultado directamente desde la plataforma online y no está disponible para su descarga.**",
                    "",
                    "Esto se debe, por un lado, a **motivos de protección de derechos de autor y propiedad intelectual del contenido**, y por otro, a que de esta forma podemos **garantizar que el material esté siempre actualizado** con mejoras, cambios legislativos y nuevos recursos.",
                ].join("\n"),
                enabled: true,
            },
        ],
    },
    // Entrenamientos y pruebas físicas
    {
        id: "entrenamientos-y-pruebas-fisicas",
        name: "Entrenamientos y pruebas físicas",
        description: "Preguntas frecuentes sobre los entrenamientos y pruebas físicas.",
        enabled: true,
        faqs: [
            {
                id: 1,
                question: "¿Si compro un pack en un centro puedo cambiar a otro centro?",
                answer: [
                    "No, las reservas de entrenamientos se deben realizar en el mismo centro donde se ha adquirido el pack o la tarifa plana.",
                    "Cada pack o tarifa está vinculado al centro de compra y no es transferible a otros centros.",
                    "Para entrenar en otro centro, será necesario adquirir un nuevo pack o tarifa en ese centro.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 2,
                question: "¿Puedo modificar una reserva de una clase física ya reservada? ",
                answer: [
                    "Sí, podrás modificarla siempre que no queden menos de 48 horas para la clase.",
                    "",
                    "La modificación estará sujeta a la disponibilidad de plazas en la nueva clase seleccionada.",
                    "",
                    "Una vez superado ese plazo, no será posible realizar cambios en la reserva.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 3,
                question: "Me he puesto enfermo y no podré asistir a la clase que tenía reservada, ¿puedo modificar la reserva?",
                answer: [
                    "Sí, podrás modificarla siempre y cuando presentes un justificante médico y hayas avisado antes de que se realizara el entrenamiento.",
                    "La modificación estará sujeta a la disponibilidad de plazas en otra clase.",
                    "En caso de no cumplir estas condiciones, la reserva se considerará consumida.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 4,
                question: "He comprado un pack, ¿puedo reservar clases para mí y otra persona?",
                answer: [
                    "No, los packs son intransferibles y de uso exclusivo para la persona que los adquiere.",
                    "Cada reserva consume una sesión del titular del pack.",
                    "Para otra persona será necesario adquirir su propio pack o tarifa.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 5,
                question: "He comprado un pack de físicas que finalmente no voy a usar, ¿cuánto tiempo tengo para solicitar la devolución?",
                answer: [
                    "Dispones de un plazo de 5 días para solicitar la devolución, siempre que no se haya utilizado ninguna de las clases incluidas en el pack.",
                    "",
                    "No se reembolsará, bajo ningún concepto, la parte proporcional del pack ni clases individuales del mismo.",
                ].join("\n"),
                enabled: true,
            },
        ],
    },
    // Planes iOpos
    {
        id: "planes",
        name: "Planes iOpos",
        description: "Preguntas frecuentes sobre los Planes iOpos.",
        enabled: true,
        faqs: [
            {
                id: 1,
                question: "¿Puedo devolver un Plan antes de la finalización?",
                answer: [
                    "El usuario podrá solicitar la devolución del Plan dentro de los **5 días naturales** posteriores a la fecha de compra.",
                    "",
                    "Una vez superado dicho plazo, no se admitirán cancelaciones ni reembolsos bajo ningún concepto.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 2,
                question: "¿Cuántos libros puedo pedir?",
                answer: [
                    "Puedes pedir hasta dos libros físicos cada mes.",
                    "",
                    "Los libros no pueden repetirse: una vez solicitado uno, no podrás volver a pedirlo durante los 12 meses de vigencia del plan.",
                    "",
                    "Aunque se actualice la edición, solo se podrá solicitar un ejemplar de ese mismo libro durante la vigencia del plan.",
                    "",
                    "Esto te ayudará a construir tu propia biblioteca de estudio a lo largo del año y a combinar la pantalla con el libro para mejorar la retención y la concentración.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 3,
                question: "¿Se puede pausar o interrumpir el Plan iOpos?",
                answer: [
                    "El Plan iOpos no admite pausas, suspensiones ni interrupciones temporales. La duración del Plan es de **12 meses consecutivos** desde la fecha de activación.",
                    "",
                    "La falta de uso durante dicho periodo no dará lugar a ampliaciones, pausas ni compensaciones.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 4,
                question: "¿No puedes fraccionar al comprar el Plan iOpos?",
                answer: [
                    "El pago del **Plan iOpos** debe realizarse en un único abono desde nuestra plataforma. **iOpos no financia compras ni ofrece fraccionamiento propio**.",
                    "",
                    "Si en tu compra aparece alguna opción de financiación o pago fraccionado, será **un servicio de PayPal**, no nuestro. Esa opción depende exclusivamente de PayPal y de tu evaluación como usuario.",
                    "",
                    "En resumen: **nosotros no financiamos**. Si PayPal no aprueba el fraccionamiento o necesitas valorar alguna alternativa, puedes escribirnos a [info@iopos.academy](mailto:info@iopos.academy) y revisaremos tu caso de forma personalizada.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 5,
                question: "¿El curso presencial de ACTIC está incluido en el Plan iOpos?",
                answer: [
                    "No. **El curso presencial de ACTIC no está incluido dentro del Plan iOpos.**",
                    "",
                    "Al tratarse de una formación que se realiza a través de **un centro homologado**, implica una serie de **costes asociados a la organización, certificación y gestión del examen**, por lo que se ofrece como **un servicio independiente**.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 6,
                question: "¿Entran los cursos Homologados en el Plan iOpos?",
                answer: [
                    "No. **Los cursos homologados no están incluidos dentro del Plan iOpos.**",
                    "",
                    "Al tratarse de una formación que se realiza a través de **un centro homologado**, implica una serie de **costes asociados a la organización, certificación y gestión del examen**, por lo que se ofrece como **un servicio independiente**.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 7,
                question: "Soy alumno del Plan iOpos y tengo reservada una preparación y/o un simulacro de entrevista. ¿Puedo modificar la fecha?",
                answer: [
                    "**Sí, es posible modificar la cita**, pero la solicitud de cambio deberá realizarse con un mínimo de **5 días de antelación obligatorios** respecto a la fecha original.",
                    "",
                    "**Importante:** la preparación o simulacro de entrevista implica la **reserva de aula** y la **asignación de uno o dos formadores**, según el tipo de entrevista.",
                    "",
                    "Este proceso conlleva **costes y una planificación previa**, por lo que es imprescindible avisar con suficiente antelación.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 8,
                question: "Soy alumno del Plan iOpos, me he inscrito en un curso presencial y no he asistido. ¿Puedo repetir el curso en otra edición?",
                answer: [
                    "**No.** Los **cursos presenciales** se consideran **disfrutados una vez reservada la plaza**, con independencia de que el alumno finalmente asista o no a la sesión programada. Por este motivo, la **no asistencia no da derecho** a **repetir el curso en otra edición** ni a **recuperar la plaza en fechas posteriores**.",
                    "",
                    "**Importante:** La **inscripción en un curso presencial** implica la **reserva de aula**, la **planificación del grupo** y la **asignación de formadores**, lo que conlleva **costes organizativos** y una **gestión previa del curso**.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 9,
                question: "¿Cuándo se me acaba el acceso a los cursos online y presenciales?",
                answer: [
                    "El acceso a los cursos de iOpos finaliza en el momento en que concluye la duración de tu **Plan iOpos anual**, independientemente de la fecha del examen oficial.",
                    "",
                    "Una vez vencido el plan:",
                    "",
                    "- No podrás acceder a ningún curso online.",
                    "- No podrás asistir a clases presenciales.",
                    "- Se cancelará cualquier suscripción activa dentro de las aplicaciones o plataformas facilitadas.",
                    "- No podrás beneficiarte de entrevistas, simulacros, tutorías ni otros servicios incluidos en el plan.",
                    "- Se perderá el acceso a cualquier contenido o recurso no utilizado durante la vigencia del plan.",
                    "",
                    "Aunque en la web pueda indicarse que los cursos individuales están disponibles hasta la fecha de examen, en el caso del **Plan iOpos** estos cursos se habilitan como parte del plan anual, por lo que no tienen una duración individual propia.",
                    "",
                    "Su acceso queda condicionado exclusivamente a la vigencia del plan, y finaliza automáticamente al cumplirse los **365 días** desde su activación.",
                ].join("\n"),
                enabled: true,
            },
        ],
    },
    // Entrevistas y simulacros de entrevista
    {
        id: "entrevistas",
        name: "Entrevistas",
        description: "Preguntas frecuentes sobre las entrevistas o simulacros de entrevista.",
        enabled: true,
        faqs: [
            {
                id: 1,
                question: "¿Puedo solicitar la devolución de una entrevista?",
                answer: [
                    "La devolución de la entrevista **solo será posible si se solicita con un mínimo de 5 días de antelación** a la fecha programada.",
                    "",
                    "**Bajo ningún concepto se realizará la devolución** si este plazo no se cumple.",
                    "",
                    "Esto se debe a que la entrevista o simulación de entrevista implica la **reserva de un aula** y la **asignación de uno o dos formadores**, según el tipo de entrevista, lo que conlleva **costes y una organización previa**.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 2,
                question: "¿Puedo pedir la devolución del test Biodata?",
                answer: [
                    "En caso de **no superar alguna de las pruebas** vinculadas a este curso, el alumno tendrá derecho a la **devolución del 50 % del importe abonado**.",
                    "",
                    "Este criterio se establece debido a que, con anterioridad, el alumno ya habrá dispuesto de **acceso al test oficial, a la gráfica y al informe personalizado**, así como a **todos los contenidos del campus en línea**.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 3,
                question: "¿Puedo solicitar la modificación de una preparación o simulacro de entrevista?",
                answer: [
                    "**Sí, es posible solicitar el cambio**, pero deberá realizarse con un mínimo de **5 días de antelación obligatorios** respecto a la fecha original de la cita.",
                    "",
                    "**Importante:** la entrevista o simulacro implica la **reserva de un aula** y la **asignación de uno o dos formadores**, según el tipo de entrevista.",
                    "",
                    "Esto conlleva **costes y una planificación previa**, por lo que es imprescindible avisar con suficiente antelación.",
                ].join("\n"),
                enabled: true,
            },
        ],
    },
    // Cuenta y perfil - Actualmente no hay FAQs
    {
        id: "cuenta-y-perfil",
        name: "Cuenta y perfil",
        description: "",
        enabled: false,
        faqs: [],
    },
    // Pagos y facturación - Actualmente no hay FAQs
    {
        id: "pagos-y-facturacion",
        name: "Pagos y facturación",
        description: "Preguntas frecuentes sobre métodos de pago, financiación y facturación.",
        enabled: true,
        faqs: [
            {
                id: 1,
                question: "¿Financiáis vosotros las compras o los pagos a plazos?",
                answer: [
                    "**No. iOpos no financia compras ni ofrece pagos a plazos propios.**",
                    "",
                    "Si en el proceso de pago aparece alguna opción de fraccionamiento, dependerá exclusivamente de **PayPal** y de los criterios que PayPal aplique a tu cuenta. **Nosotros no podemos activarla, aprobarla ni modificarla.**",
                    "",
                    "Si necesitas una alternativa, puedes escribirnos a [info@iopos.academy](mailto:info@iopos.academy) y te orientaremos sobre las opciones disponibles, pero el fraccionamiento **nunca lo gestiona iOpos directamente**.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 2,
                question: "¿Qué métodos de pago tenéis disponibles para completar la compra?",
                answer: [
                    "En el checkout puedes encontrar estos métodos de pago: **PayPal**, **tarjeta de crédito o débito**, **Apple Pay** y **Google Pay**.",
                    "",
                    "La disponibilidad de cada uno puede variar según el pedido, el dispositivo, el navegador o la configuración de PayPal. Si solo hay un método compatible, el sistema puede dejarlo seleccionado automáticamente para simplificar la compra.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 3,
                question: "¿Cómo funciona el pago con PayPal?",
                answer: [
                    "Puedes pagar con tu cuenta de **PayPal** de forma habitual. En algunos casos, PayPal también puede mostrar opciones como **pago en plazos** o financiación, pero esa decisión depende exclusivamente de PayPal.",
                    "",
                    "**iOpos no interviene** en la aprobación, gestión ni condiciones de esas opciones. Si PayPal no te las muestra, no podemos activarlas manualmente.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 4,
                question: "¿Puedo pagar con tarjeta de crédito o débito?",
                answer: [
                    "Sí. Cuando la opción está disponible, puedes pagar con **tarjeta de crédito o débito** desde la pasarela segura de PayPal.",
                    "",
                    "Los datos de la tarjeta se introducen en **campos cifrados** y no pasan por nuestro sistema. El cobro se procesa mediante PayPal, que actúa como proveedor de pagos.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 5,
                question: "¿Puedo pagar con Apple Pay o Google Pay?",
                answer: [
                    "Sí, siempre que tu dispositivo y tu cuenta sean compatibles y el método esté disponible en ese momento.",
                    "",
                    "**Apple Pay** y **Google Pay** pueden aparecer como métodos independientes dentro del checkout. Su disponibilidad depende del navegador, del dispositivo y de la configuración del propio proveedor de pagos.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 6,
                question: "¿Los pagos son seguros?",
                answer: [
                    "Sí. El pago se realiza mediante las pasarelas de **PayPal** y sus integraciones, de modo que los datos sensibles no se gestionan directamente desde nuestra web.",
                    "",
                    "Además, el checkout utiliza **campos protegidos** y opciones de pago verificadas por el propio proveedor, lo que añade una capa extra de seguridad durante la compra.",
                ].join("\n"),
                enabled: true,
            },
        ],
    },
    // Cursos Formación Policial
    {
        id: "cursos-formacion-policial",
        name: "Cursos Formación Policial",
        description: "",
        enabled: true,
        faqs: [
            {
                id: 1,
                question: "¿Puedo solicitar la devolución de un curso?",
                answer: [
                    "**No.** Una vez realizada la inscripción, no se admiten devoluciones, al tratarse de cursos con **plaza limitada** y **planificación previa**.",
                    "",
                    "No obstante, se podrá solicitar el **cambio por otro curso homologado** en el que queden plazas disponibles, siempre y cuando tenga el **mismo precio**.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 2,
                question: "¿Estos cursos realmente puntúan en la oposición?",
                answer: [
                    "**Sí. Actualmente, 17 de nuestros cursos están homologados por el Institut de Seguretat Pública de Catalunya (ISPC)**, por lo que son baremables como méritos formativos según las bases de cada convocatoria.",
                    "",
                    "Es importante que revises la información de cada curso para comprobar si está **homologado**, ya que no todos los cursos cuentan con homologación.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 3,
                question: "¿Cuántas horas tienen los cursos?",
                answer: [
                    "Cada curso tiene una **carga lectiva específica** (por ejemplo: 26h, 36h, etc.), que se detalla en la **ficha del curso** y en el **certificado final**.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 4,
                question: "¿Cómo se realizan los cursos?",
                answer: [
                    "Existen dos modalidades de cursos homologados en iOpos:",
                    "1. **Cursos semipresenciales**",
                    "   · Parte online (carga lectiva en el campus)",
                    "   · Parte presencial (clase + examen final el mismo día)",
                    "**Es obligatorio asistir a la parte presencial, completar el 100% del campus y superar el examen para obtener el certificado final.**",
                    "",
                    "2. **Cursos online**",
                    "   · Formación 100% a través del campus",
                    "   · Deberás reservar día y hora para realizar el examen presencial obligatorio",
                    "**Es obligatorio completar el 100% del campus y superar el examen para obtener el certificado final.**",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 5,
                question: "Si el curso no está homologado, ¿también tendré que asistir presencialmente a realizar el examen?",
                answer: [
                    "**No.** En los cursos no homologados, el examen se realiza directamente desde nuestra plataforma online, sin necesidad de asistencia presencial.",
                    "",
                    "Ten en cuenta que, al no estar homologado, **no contará como mérito formativo baremable**.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 6,
                question: "Si adquiero un curso que no está homologado y posteriormente pasa a estar homologado, ¿podré obtener el certificado homologado?",
                answer: [
                    "**No. La homologación no es retroactiva.** Los cursos homologados requieren cumplir una serie de condiciones específicas desde el inicio, como la **planificación académica**, **reserva de aulas**, **asignación de profesorado** y **realización de pruebas presenciales bajo control oficial**.",
                    "",
                    "Por este motivo, solo podrán obtener el certificado homologado aquellos alumnos que hayan realizado el curso dentro de su edición ya homologada.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 7,
                question: "¿Cuántos puntos me dará el curso?",
                answer: [
                    "La puntuación no es fija. Depende de la convocatoria, pero normalmente se valora en función de las **horas del curso** y su **homologación**.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 8,
                question: "¿Puedo hacer varios cursos homologados a la vez?",
                answer: [
                    "**Sí**, siempre que puedas cumplir con los requisitos de cada uno (especialmente asistencia y exámenes). Es responsabilidad del alumno organizarse correctamente.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 9,
                question: "¿Cuándo recibiré el certificado?",
                answer: [
                    "El certificado se emitirá a los **30 días de la compra del curso**, y siempre y cuando se haya **superado el examen presencial** y se hayan **validado los resultados**.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 10,
                question: "¿Puedo hacer el curso solo online?",
                answer: [
                    "Depende del tipo de curso:",
                    "- **Cursos homologados**: no se pueden realizar únicamente online, ya que requieren una **parte presencial obligatoria** para cumplir con los requisitos oficiales (clases y/o examen presencial).",
                    "",
                    "- **Cursos no homologados**: sí se pueden realizar 100% online, incluyendo la formación y el examen a través de nuestra plataforma.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 11,
                question: "¿Se puede descargar el material del campus?",
                answer: [
                    "**No.** El material del campus está diseñado para ser consultado directamente desde la plataforma online y no está disponible para su descarga.",
                    "",
                    "Esto se debe a **motivos de protección de derechos de autor y propiedad intelectual**, y también a que así podemos garantizar que el contenido esté siempre actualizado con mejoras, cambios legislativos y nuevos recursos.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 12,
                question: "No he realizado el curso 100% online ni me he presentado al examen dentro de los 30 días de acceso al campus. ¿Podéis reactivármelo sin coste?",
                answer: [
                    "**No.** Una vez finalizado el periodo de acceso, no se puede reactivar el curso sin coste.",
                    "",
                    "La plataforma de formación que utilizamos es un servicio externo que nos factura por cada **usuario activo** y por cada **matrícula realizada**. Esto implica que, en el momento de la inscripción, se genera un coste automático para la academia, independientemente de si se utiliza el curso o no.",
                    "",
                    "Por este motivo, reactivar el acceso supone generar una nueva matrícula, lo que conlleva un coste adicional que la academia no puede asumir.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 13,
                question: "¿Puedo cambiar el horario de un curso una vez inscrito?",
                answer: [
                    "**No se permiten cambios de horario ni cambios de curso en los últimos 5 días antes del inicio del curso**, ni una vez que el curso ya ha comenzado.",
                    "",
                    "Si necesitas realizar un cambio, deberás solicitarlo **con al menos 5 días de antelación**.",
                    "",
                    "Esto nos permite reorganizar de forma adecuada la planificación de los profesores y asegurar el buen funcionamiento del curso.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 14,
                question: "¿Qué ocurre si no asisto al curso semipresencial homologado del ISPC y no aviso previamente?",
                answer: [
                    "Los cursos semipresenciales homologados del ISPC requieren una **planificación estricta**, que incluye la asignación del profesorado, la reserva de espacios, el control de aforo y el cumplimiento de los requisitos establecidos por el organismo homologador.",
                    "",
                    "Por este motivo, si un alumno no asiste al curso y **no avisa previamente (mínimo 5 días de antelación)**, **no es posible reubicarlo en otro grupo ni cambiar su asistencia a otra fecha**. Cada grupo dispone de plazas limitadas, y cuando un alumno no asiste sin comunicarlo, ocupa un lugar que podría haber aprovechado otra persona.",
                    "",
                    "Además, en estos casos **tampoco se podrá solicitar la devolución del importe abonado**, ya que la plaza ha sido reservada y los recursos necesarios se han planificado específicamente para el alumno.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 15,
                question: "¿Me he matriculado en varios cursos homologados. ¿Puedo hacer los exámenes el mismo día?",
                answer: [
                    "Sí, puedes realizar los **exámenes el mismo día** siempre que no se trate de cursos **semipresenciales**.",
                    "",
                    "En el caso de los cursos **semipresenciales**, el examen se realiza únicamente el día de la **sesión presencial**, por lo que no es posible unificarlo con otros exámenes.",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 16,
                question: "¿Cuándo se realiza el examen en los cursos online y presenciales?",
                answer: [
                    "**Los exámenes de los cursos online:** El examen se realiza de forma presencial el último viernes de cada mes. Deberás realizarlo dentro de los 30 días siguientes a la fecha de compra del curso.",
                    "",
                    "**Los exámenes de los cursos presenciales:** El examen se realiza el mismo día en que asistes a la clase presencial.",
                    "",
                    "Si tienes dudas, puedes escribirnos a [cursosformacion@iopos.es](mailto:cursosformacion@iopos.es)",
                ].join("\n"),
                enabled: true,
            },
            {
                id: 17,
                question: "¿Si llego tarde una sesisón semipresencial podré acceder igualmente?",
                answer: [
                    "**No.** Para la obtención del certificado es obligatorio acreditar el **100% de asistencia** a las horas presenciales del curso, además de **superar la evaluación correspondiente**.",
                    "",
                    "Por este motivo, es **responsabilidad del alumno** acudir con suficiente antelación al inicio de la sesión. Si un alumno llega tarde y no puede acceder a la actividad formativa, **las horas no podrán ser certificadas** y **no será posible recuperarlas** en otra edición, grupo o convocatoria del curso.",
                    "",
                    "Te recomendamos planificar tu asistencia con tiempo suficiente para evitar incidencias. Recuerda que la **asistencia completa a la parte presencial** y la **superación del examen final** son **requisitos indispensables** para la expedición del certificado correspondiente.",
                ].join("\n"),
                enabled: true,
            },
        ],
    },
];
exports.default = categories;
